import React, { useEffect, useMemo, useRef, useState } from "react";
import ModalVideo from "react-modal-video";
import ProfileContainer from "../components/ProfileContainer";
import { List, Typography } from "antd";

const MAX_LENGTH = 20;

const TalentProfileInterviews = ({ items = [] }) => {
    const [isMoreOpen, setIsMoreOpen] = useState(false);

    const [previewingVideo, setPreviewingVideo] = useState(null)

    const steps = useMemo(() => {
        if (!items?.length) {
            return [];
        }

        return TB.orderBy(laravel.talent_video_interview_steps || [], 'display_index', 'asc').reduce((acc, curr) => {
            let existingStep = TB.find(items || [], ['step.id', curr.id]);

            if (existingStep) {
                let { step: stepInfo, ...latest_interview } = existingStep;
                return [...acc, { ...curr, latest_interview }]
            }
            return [...acc]
        }, [])
    }, [items]);


    return (
        <>
            <ModalVideo
                channel="custom"
                url={previewingVideo}
                isOpen={!!previewingVideo}
                onClose={() => setPreviewingVideo(false)}
            />
            <div id="interviews" className="pt-2 pb-8">
                <ProfileContainer>
                    <div>
                        <div className="flex flex-row items-start justify-between pb-6">
                            <h4 className="textbold text-lg">Interviews  {!!items?.length && `(${items?.length})`}</h4>
                        </div>

                        {!items?.length && (
                            <div className="py-8 text-center">
                                <p className="text-base">No Interviews Available</p>
                            </div>
                        )}

                        <div className="flex gap-4 flex-wrap">

                            <List itemLayout="vertical" dataSource={steps} renderItem={(item, index) => (
                                <List.Item className="border-t first:border-t-0 py-4">
                                    <TalentInterviewStep
                                        step={item}
                                        index={index}
                                        onPreview={setPreviewingVideo} />
                                </List.Item>
                            )} />

                        </div>

                        {items?.length > MAX_LENGTH && (
                            <div className="pt-6 flex justify-end">
                                <button
                                    type="button"
                                    className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                    onClick={() => setIsMoreOpen(!isMoreOpen)}
                                >
                                    <p>{items?.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                    <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                        <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isMoreOpen })} />
                                    </div>
                                </button>
                            </div>
                        )}
                    </div>
                </ProfileContainer>
            </div>
        </>
    )
}

export default TalentProfileInterviews;


const TalentInterviewStep = ({ step, onPreview, onUpdate, index }) => {
    const videoRef = useRef(null);
    const [videoLength, setVideoLength] = useState(0);

    useEffect(() => {
        if (videoRef?.current) {
            const totalSeconds = videoRef?.current.duration;

            // Method 2: Wait for metadata to load (more reliable)
            videoRef?.current.addEventListener('loadedmetadata', () => {
                const totalSeconds = videoRef?.current.duration;
                console.log('Video duration in seconds:', totalSeconds);
                try {
                    if (videoRef?.current) {
                        setVideoLength(Math.ceil(totalSeconds));
                    }
                } catch (e) {
                    console.error(e);
                }
            });
        }
    }, [videoRef]);


    return (
        <div className="flex items-start flex-nowrap gap-4">
            <div className="bg-secondary text-white min-w-8 min-h-8 w-8 h-8 rounded-full flex items-center justify-center">
                {/* <span className=" font-semibold">{step.display_index}</span> */}
                <span className="font-semibold">{index + 1}</span>

            </div>
            <div className="flex flex-col flex-grow items-stretch gap-3">
                <div className="flex flex-col items-stretch flex-grow">
                    <Typography.Text strong className="text-base">
                        {step.question}
                    </Typography.Text>
                    {step.description && (
                        <div className="text-xs text-gray-500 mt-2"
                            dangerouslySetInnerHTML={{ __html: step.description.replace(/<br\s*[\/]?>/gi, ". ") }} />
                    )}
                    <Typography.Text type="secondary text-xs mt-1.5">
                        Video response&nbsp; | &nbsp;{TB.pluralize('sec', videoLength || step.target_length_seconds, true)}
                    </Typography.Text>

                </div>

                <div className="flex flex-col items-stretch flex-1">
                    {step.latest_interview ? (
                        <div className="flex flex-col-reverse gap-2">

                            <div>
                                <div>
                                    <div className="flex flex-row gap-6 items-center">
                                        <div className="relative inline-flex items-start self-start flex-col bg-gray-200 rounded-lg overflow-hidden">
                                            <div className="min-w-52 w-52 relative min-h-[117px] h-[117px]">
                                                <video
                                                    ref={videoRef}
                                                    // src={step.latest_interview.video_path}
                                                    src={`${step.latest_interview.video_path}#t=3`}
                                                    controls={false}
                                                    width="100%"
                                                    height="100%"
                                                    className="rounded object-contain"
                                                />
                                            </div>


                                            <div className="absolute inset-0 bg-black bg-opacity-20 flex flex-col items-center justify-center">
                                                <i
                                                    className="fas fa-play text-white opacity-70 fa-2x clickable"
                                                    onClick={() => {
                                                        onPreview(step.latest_interview.video_path)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    ) : (
                        <div className="min-w-52 w-52 flex flex-col gap-3">
                            <p className="italic text-xs text-gray-400 font-medium mb-2 underline whitespace-nowrap">
                                Not started
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
};